import { Button, Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  onClick: () => void;
  helpCenterArticleUrl?: string;
};

export const ReviewSyncSettingsWarning = ({
  onClick,
  helpCenterArticleUrl,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Callout
      className="my-16"
      title={t('company.reviewSyncSettingsWarning.title')}
      variant="warning"
    >
      <p className="mb-8">{t('company.reviewSyncSettingsWarning.content')}</p>
      <Button
        variant="secondaryNeutral"
        text={t('company.reviewSyncSettingsWarning.action')}
        onClick={onClick}
      />
      {helpCenterArticleUrl && (
        <Button
          iconName="arrow-top-right-square"
          iconPosition="right"
          variant="tertiaryNeutral"
          text={t('company.reviewSyncSettingsWarning.helpCentreLink')}
          href={helpCenterArticleUrl}
          component="a"
          target="_blank"
        />
      )}
    </Callout>
  );
};
